var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        "custom-class": "outDialog",
        center: "",
        visible: _vm.dialogVisible,
        width: "34%",
        "show-close": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "header" }, [
        _c("span", [_vm._v(_vm._s(_vm.titieMap[_vm.state]) + " 直采特价")]),
      ]),
      _c(
        "main",
        { staticClass: "main" },
        [
          _vm.state === 0 ? _c("hotelDirectMining") : _vm._e(),
          _vm.state === 1 ? _c("siteDirectMining") : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "saveBtn", on: { click: _vm.sendPopup } },
            [_vm._v("快马加鞭 让资源方速速给我个报价")]
          ),
        ],
        1
      ),
      _c("directSendPopup", {
        ref: "directSendPopup",
        attrs: { state: _vm.state },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }